import React, { lazy, Suspense } from "react";

const LazyContactDetail = lazy(() => import("./ContactDetail"));

const ContactDetail = (
  props: (JSX.IntrinsicAttributes & { children?: React.ReactNode }) | any
) => (
  <Suspense fallback={null}>
    <LazyContactDetail {...props} />
  </Suspense>
);

export default ContactDetail;
